import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CratesDataSourceService } from 'src/app/core/data-sources/crates-data-source.service';
import { trigger, state, animate, style, transition } from '@angular/animations';
import { EventType } from 'src/models/History';

@Component({
  selector: 'app-pallet-transfer',
  templateUrl: './pallet-transfer.component.html',
  styleUrls: ['./pallet-transfer.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class PalletTransferComponent implements OnInit {
  @Input() show: boolean = false;
  @Input() data;
  @Output() openPalletDetailsRequested = new EventEmitter<any>();
  eventType = EventType;
  displayedColumns = ['sku', 'name', 'quantity'];
  infoLabel = 'Pallet Transferido';
  columnDefinition = [
    { key: 'sku', text: "Código do Item" },
    { key: 'name', text: "Nome" },
    { key: 'quantity', text: "Quantidade", alignRight: true }
  ];

  constructor(private cratesDataSourceService: CratesDataSourceService) { }

  ngOnInit(): void {
    this.infoLabel = this.data.type === this.eventType.TRANSFER_IN ? 'Pallet de Origem' : 'Pallet de Destino'
  }

  getPalletValues(label: 'rfid' | 'position' | 'levelName') {
    const data = this.data.type === EventType.TRANSFER_IN ? this.data.originCrate : this.data.destinationCrate;
    switch (label) {
      case 'rfid':
        return data.tagRfid || '---';
      case 'position':
        return data.groundPositionAlias || '---';
      case 'levelName':
        return data.groundPositionGroupLevelName || '---';
    }
  }

  async openPalletDetails(crate) {
    const crateId = this.data.type === EventType.TRANSFER_IN ? crate.originCrate.crateId : crate.destinationCrate.crateId;
    const res = await this.cratesDataSourceService.getCrateById(crateId);
    if (res) {
      const palletData = {
        item: res.crate,
        itemDetails: res,
        isExit: false,
        page: 0
      };
      this.openPalletDetailsRequested.emit(palletData);
    }
  }

}
